import { render, staticRenderFns } from "./RulePage.vue?vue&type=template&id=8b1c77b4&scoped=true"
import script from "./RulePage.vue?vue&type=script&lang=js"
export * from "./RulePage.vue?vue&type=script&lang=js"
import style0 from "./RulePage.vue?vue&type=style&index=0&id=8b1c77b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1c77b4",
  null
  
)

export default component.exports